import React from 'react';
import { MailOpen, MessageCircle } from 'lucide-react';

const StatsOverview = ({ totalMessages, unreadCount }) => {
  const readCount = totalMessages - unreadCount;
  const readPercentage = totalMessages > 0 ? Math.round((readCount / totalMessages) * 100) : 0;

  return (
    <div className="bg-white border-b border-gray-200">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 md:p-6">
        <div className="bg-blue-50 rounded-lg p-4 flex items-center shadow-sm">
          <div className="rounded-full bg-blue-100 p-3 mr-4">
            <MessageCircle className="h-6 w-6 text-blue-600" />
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500">Total Messages</h3>
            <p className="text-2xl font-bold text-gray-900">{totalMessages}</p>
          </div>
        </div>
        
        <div className="bg-indigo-50 rounded-lg p-4 flex items-center shadow-sm">
          <div className="rounded-full bg-indigo-100 p-3 mr-4">
            <MailOpen className="h-6 w-6 text-indigo-600" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-medium text-gray-500">Read Status</h3>
            <div className="flex items-center justify-between">
              <p className="text-2xl font-bold text-gray-900">{readCount} / {totalMessages}</p>
              <span className="text-indigo-600 font-medium text-sm">
                {readPercentage}% Read
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
              <div 
                className="bg-indigo-600 h-2.5 rounded-full transition-all duration-500 ease-out" 
                style={{ width: `${readPercentage}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;